<script setup>
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';

const props = defineProps({
    modelValue: { required: false, type: [String, null] },
});

const mathField = ref(null);

let emit = defineEmits(['update:modelValue']);

const expression = useVModel(props, 'modelValue', emit);

watch(
    () => props.modelValue,
    (newVal) => {
        mathField.value.setValue(newVal);
    },
);
</script>
<script>
export default {
    name: 'LatexDisplay',
};
</script>

<template>
    <div>
        <math-field read-only style ref="mathField">
            {{ expression }}
        </math-field>
    </div>
</template>
